// Chakra imports
import { Box, Flex, useColorModeValue } from "@chakra-ui/react";
import { Outlet } from "@remix-run/react";

// Custom components
import Card from "components/card/Card";
import { FooterComponent } from "components/footer/FooterComponent";
import { useRef } from "react";

function AuthCentered(props: {
  image?: string;
  cardTop?: { [x: string]: string | number };
  cardBottom?: { [x: string]: string | number };
}) {
  const { image, cardTop, cardBottom } = props;
  const backgroundBoxRef = useRef(null);

  return (
    <Flex
      direction="column"
      alignSelf="center"
      justifySelf="center"
      overflow="hidden"
      px="10px"
      minH="100vh"
      width="100%"
    >
      <Box
        ref={backgroundBoxRef}
        position="absolute"
        // minH={{ base: "50vh", md: "50vh" }}
        // maxH={{ base: "50vh", md: "50vh" }}
        w={{ md: "calc(100vw)" }}
        maxW={{ md: "calc(100vw)" }}
        h="180px"
        // h={{ base: "140px", md: "180px" }}
        left="0"
        right="0"
        bgRepeat="no-repeat"
        overflow="hidden"
        top="0"
        bgImage={image}
        mx="auto"
      />
      <Card
        w="100%"
        h="max-content"
        mx="auto"
        maxW="420px"
        mt={cardTop}
        mb={cardBottom}
        p="10px"
        pt="30px"
      >
        <Outlet context={{ backgroundBoxRef }} />
      </Card>
      <FooterComponent />
    </Flex>
  );
}

// Custom Chakra theme
export default function MainLayout() {
  const authBg = useColorModeValue("white", "navy.900");

  return (
    <Box>
      <Box
        bg={authBg}
        float="right"
        minHeight="100vh"
        height="100%"
        position="relative"
        w="100%"
        transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
        transitionDuration=".2s, .2s, .35s"
        transitionProperty="top, bottom, width"
        transitionTimingFunction="linear, linear, ease"
      >
        <Box mx="auto" minH="100vh">
          <AuthCentered
            image={"linear-gradient(135deg, #868CFF 0%, #4318FF 100%)"}
            cardTop={{ base: "140px" }}
            cardBottom={{ base: "50px" }}
          />
        </Box>
      </Box>
    </Box>
  );
}
